module.exports = __webpack_public_path__ + "img/tem_img2.1a2ede01.jpg";